import { defineComponent } from "vue";
import common from "../core/core";

import { Swiper, SwiperSlide } from "swiper/vue";
import { Swiper as SwiperCreator } from "swiper";

export default defineComponent({
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      featuresSwiper: null,
      featuresTabIndex: 0,
    };
  },
  mounted() {
    this.featuresSwiper = new SwiperCreator(this.$refs.swiperContainer as HTMLElement, {
      slidesPerView: "auto",
      allowTouchMove: false,
    });
  },
  computed: {},
  methods: {
    changeFeaturesTab(index: number) {
      this.featuresTabIndex = index;
      this.featuresSwiper.slideTo(index);
    },
  },
  mixins: [common],
});
